import { useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { contabilizacionApi } from "@/features/contabilizacion/services/contabilizacion.api";

/**
 * Query auxiliar para mostrar el badge "N pólizas" en el tab del
 * detalle · comparte queryKey con `<PolizasCard>` (que consume la
 * lista completa).
 */
export function usePolizas(solicitudId: string, enabled: boolean) {
  return useQuery({
    queryKey: qk.polizas(solicitudId),
    queryFn: () => contabilizacionApi.listarPolizas(solicitudId),
    enabled,
    refetchInterval: 5_000,
  });
}
